/** RobinhoodSpace — citizen-facing workflow labels (not internal GovOps names). */
export const WORKFLOW_STATE_OPTIONS = [
  'intake',
  'under_review',
  'notice_sent',
  'violation_open',
  'payment_pending',
  'payment_received',
  'payment_overdue',
  'renewal_due',
  'renewal_notice_sent',
  'expired',
  'resolved',
  'closed',
  'appealed',
];

export const STATUS_LABELS = {
  intake: 'Intake received',
  under_review: 'Under review',
  notice_sent: 'Notice sent',
  violation_open: 'Violation open',
  payment_pending: 'Payment pending',
  payment_received: 'Payment received',
  payment_overdue: 'Payment overdue',
  renewal_due: 'Renewal due',
  renewal_notice_sent: 'Renewal notice sent',
  expired: 'Expired',
  resolved: 'Resolved',
  closed: 'Closed',
  appealed: 'Appeal in progress',
};

export const PAYMENT_STATUS_LABELS = {
  unpaid: 'Unpaid',
  pending: 'Pending',
  paid: 'Paid',
  overdue: 'Overdue',
};

export function formatPaymentStatus(status) {
  return PAYMENT_STATUS_LABELS[status] || status || '—';
}

export function formatStatus(status) {
  return STATUS_LABELS[status] || status || 'Unknown';
}

/** Status values allowed in edit dropdown for the current GovOps state. */
export { getAllowedNextStatuses as getEditableStatusOptions } from '../utils/govopsWorkflowClient';

export const ACTION_LABELS = {
  case_created: 'Case opened',
  case_updated: 'Case updated',
  case_state_changed: 'Status changed',
  permit_created: 'Permit recorded',
  permit_updated: 'Permit updated',
  permit_state_changed: 'Permit status changed',
  violation_created: 'Violation filed',
  violation_updated: 'Violation updated',
  payment_created: 'Payment initiated',
  payment_received: 'Payment received',
  renewal_notice_sent: 'Renewal notice sent',
  permit_renewed: 'Permit renewed',
  permit_expired: 'Permit expired',
  vendor_created: 'Vendor registered',
};

export function formatAuditAction(action) {
  return ACTION_LABELS[action] || action || 'Activity';
}

export function formatTimestamp(value) {
  if (!value) return '—';
  if (value.seconds) return new Date(value.seconds * 1000).toLocaleString();
  try {
    return new Date(value).toLocaleString();
  } catch (_) {
    return String(value);
  }
}
